import { render, staticRenderFns } from "./hospitality.vue?vue&type=template&id=4a9daa9c&"
import script from "./hospitality.vue?vue&type=script&lang=js&"
export * from "./hospitality.vue?vue&type=script&lang=js&"
import style0 from "./hospitality.vue?vue&type=style&index=0&id=4a9daa9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports